export const ActivityIcon = require("./activityIcon.png");
export const RestaurantsIcon = require("./restaurantIcon.png");
export const AccommodationIcon = require("./accommodationIcon.png");